import * as Blockly from 'blockly/core';

// El título de categoria del flyout mide 40 en prod y 25 en la v13, que no suma
// margen vertical a los labels. No sale por CSS (el flyout lee el alto del JS) ni
// parcheando `FlyoutButton.prototype.createDom` (en la v13 es campo de instancia):
// se reemplaza el inflater de labels.
const LABEL_MARGIN_Y = 7.5;

class LegacyLabelFlyoutInflater extends Blockly.LabelFlyoutInflater {
  load(state, flyout) {
    const item = super.load(state, flyout);
    const label = item.getElement();
    const root = label.getSvgRoot && label.getSvgRoot();
    if (!root) return item;

    label.height += LABEL_MARGIN_Y * 2;

    const background = root.querySelector('rect');
    if (background) background.setAttribute('height', String(label.height));

    const text = root.querySelector('text');
    if (text) {
      const y = Number(text.getAttribute('y')) || 0;
      text.setAttribute('y', String(y + LABEL_MARGIN_Y));
    }

    return item;
  }
}

export function registerLegacyFlyoutLabel() {
  Blockly.registry.register(
    Blockly.registry.Type.FLYOUT_INFLATER,
    'label',
    LegacyLabelFlyoutInflater,
    true,
  );
}

export default registerLegacyFlyoutLabel;
